// React
import { useTranslation } from 'react-i18next';

// Libs
import { Card, Table } from 'semantic-ui-react';

// Components
import CopyContentComponent from '../../../misc/CopyContent.component';

// Services
import { numberFormat } from '../../../../services/misc/numberFormat';

// Types
import { contractState } from '../../../../model/details/contract';

type LeadContractComponentProps = {
    data: typeof contractState;
    copy?: boolean;
};

export default function LeadContractComponent(props: LeadContractComponentProps) {
    const { t } = useTranslation();

    const matrix = [
        // key of translation , key of value (currently app uses the same wording, but you can change it in the ACL)
        ['publicationId', 'publicationId'],
        ['campaignTitle', 'campaignTitle'],
        ['category', 'category'],
        ['mileage', 'mileage'],
        ['duration', 'duration'],
        [
            'rate',
            'rateNet',
            ` (${t('lead.detail.box.contract.rateNet')})`,
            ' | ',
            'rateGross',
            ` (${t('lead.detail.box.contract.rateGross')})`,
        ],
        [
            'totalPrice',
            'totalPriceNet',
            ` (${t('lead.detail.box.contract.rateNet')})`,
            ' | ',
            'totalPriceGross',
            ` (${t('lead.detail.box.contract.rateGross')})`,
        ],
        ['leasmanMasterId', 'leasmanMasterId'],
        ['leasmanContractId', 'leasmanContractId'],
    ];

    function createValue(values: Array<string | number> = []): React.ReactElement {
        const output = values.map((key) => {
            let _v = props.data[key] ? props.data[key] : key;

            switch (key) {
                case 'rateNet':
                case 'rateGross':
                case 'totalPriceNet':
                case 'totalPriceGross':
                    return numberFormat(_v, true);
                case 'leasmanMasterId':
                case 'leasmanContractId':
                    return props.data[key];
                default:
                    return numberFormat(_v) + ' ';
            }
        });

        return props.copy ? <CopyContentComponent>{output.join(' ')}</CopyContentComponent> : <>{output}</>;
    }

    return (
        <Card fluid>
            <Card.Content>
                <Card.Header>{t('lead.detail.box.contract.headline')}</Card.Header>
                <Card.Description>
                    <Table celled striped columns={2}>
                        <Table.Body>
                            {matrix.map((row: Array<string>, ix) => (
                                <Table.Row key={ix}>
                                    <Table.Cell width={4}>{t(`lead.detail.box.contract.${row[0]}`)}</Table.Cell>
                                    <Table.Cell singleLine>{createValue(row.splice(1))}</Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </Card.Description>
            </Card.Content>
        </Card>
    );
}
